import React from "react";
import { MapPin } from "lucide-react";

const LOCATIONS = [
  "Znojmo", "Nový Šaldorf-Sedlešovice", "Sedlešovice", "Dobšice",
  "Suchohrdly", "Kuchařovice", "Přímětice", "Šatov", "Chvalovice",
  "Hnanice", "Dyjákovičky", "Tasovice", "Hodonice", "Krhovice",
  "Miroslav", "Moravský Krumlov", "Jaroslavice", "Vranov nad Dyjí",
];

export default function SeoLocations() {
  return (
    <section
      id="lokalita"
      data-testid="seo-locations-section"
      aria-label="Oblasti, kde STK Komfort působí"
      className="relative bg-[#0A0D17] text-slate-300 py-16 border-t border-amber-300/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 rounded-full border border-amber-300/20 bg-amber-300/5 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-amber-300/90">
              <MapPin className="h-3 w-3" />
              Kde působíme
            </div>
            <h2 className="font-heading mt-5 text-2xl sm:text-3xl font-bold text-white tracking-tight leading-tight">
              STK Komfort pro Znojmo a celé okolí
            </h2>
            <p className="font-body mt-4 text-sm text-slate-400 leading-relaxed">
              Naše auto concierge služba pomáhá majitelům vozidel ve Znojmě
              a desítkách okolních obcí jihomoravského kraje.
            </p>
          </div>

          <div className="lg:col-span-7">
            <ul className="flex flex-wrap gap-2">
              {LOCATIONS.map((loc) => (
                <li
                  key={loc}
                  className="inline-flex items-center gap-1.5 rounded-full border border-amber-300/15 bg-white/[0.03] px-3.5 py-1.5 text-xs font-medium text-slate-200 hover:border-amber-300/35 transition-colors"
                >
                  <MapPin className="h-3 w-3 text-amber-300/70" />
                  {loc}
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs text-slate-500 leading-relaxed">
              Působíme po celém Znojemsku. Vyzvednutí v rámci Znojma od 390 Kč,
              mimo Znojmo 15 Kč/km.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
